import Ring from '@/assets/icons/loading-ring.svg?react';

import RotatingRingIconStyles from './RotatingRingIcon.module.scss';

const RotatingRingIcon = () => <Ring className={RotatingRingIconStyles.icon} />;

export default RotatingRingIcon;
